import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
export type {AxiosPromise} from 'axios';
import { FieldServiceClient } from '@dealervision/fieldservice-client';

//import { API_URL } from "./site-config";

export const API = axios.create({
    baseURL: '',
    timeout: 30000,
    withCredentials: true,
    headers: {'Content-Type': 'application/json'}
});

export const ApiClient = new FieldServiceClient({
    WITH_CREDENTIALS: true,
    HEADERS: { 'Content-Type': 'application/json' }
});


// Install interceptors

export function enableDebugLogs(axi: AxiosInstance) {
    axi.interceptors.request.use(req => {
        console.debug(`[BaseApi:Request] ${req.baseURL} ${req.method} ${req.url}`);
        return req;
    });

    axios.interceptors.response.use(res => {
        console.debug(`[BaseApi:Response] ${res.data.json}`);
        return res;
    });
}

export function enableHttpsExceptions(axi: AxiosInstance) {
    axi.interceptors.response.use(
        res => res,
        err => {
            if (err.response.status === 404) {
                throw new Error(`${err.config.url} not found`);
            }
            throw err;
        }
    );
}

export function wrap<T = any, R = AxiosResponse<T>>(promise: Promise<R>) {
    promise.catch((_error: any) => {
        return processError(_error);
    }).then((_response: any) => {
        return processResult(_response);
    });
}

export function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

export function processError(_error: any) {
    if (isAxiosError(_error) && _error.response) {
        return _error.response;
    } else {
        throw _error;
    }
}

export function processResult(response: AxiosResponse) {
    const status = response.status;
    const _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (const k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        return;
    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        const resultData404 = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("A server side error occurred.", status, _responseText, _headers, result404);
    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }

}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

export default API;

